
import React, { useContext } from 'react'
import { FiEye, FiTrash } from 'react-icons/fi'

import { Container } from './styles'
import Table from '~/components/Table'
import Spinner from '~/components/Spinner'
import { GlobalContext } from '~/contexts/GlobalContext'

export default function ({ visitas, handleOpenVisita, handleExcluirVisita, validadoresIds }) {
    const { user } = useContext(GlobalContext)

    const eValidador = validadoresIds?.includes(user?.pessoa.id)

    if (!visitas) {
        return <Spinner />
    }

    return (
        <Container>
            <Table
                headers={[
                    { value: 'Diretor(a)', name: 'pessoa_nome' },
                    { value: 'Local', name: 'instituicao_nome', centered: true },
                    { value: 'Data prevista', name: 'data_previsao_string', centered: true },
                    { value: 'Data da atividade', name: 'data_visita_string', centered: true },
                    { value: 'Período', name: 'periodo', centered: true },
                    { value: 'Duração', name: 'duracao', centered: true },
                    { value: 'Validada', name: 'validado_string', centered: true, style: { width: 100 } }
                ]}
                data={visitas}
                emptyLabel="Nenhuma atividade cadastrada"
                filterable
                legends={[
                    {
                        color: '#bdd8ff',
                        text: 'Previstas'
                    },
                    {
                        color: '#ffcdd2',
                        text: 'Em curso'
                    },
                    {
                        color: '#fff59d',
                        text: 'Concluídas e não validadas'
                    },
                    {
                        color: '#fff',
                        text: 'Concluídas e validadas'
                    }
                ]}
                actions={[
                    {
                        name: 'Visualizar',
                        action: handleOpenVisita,
                        icon: FiEye,
                        iconSize: 16
                    },
                    {
                        name: 'Excluir',
                        action: handleExcluirVisita,
                        icon: FiTrash,
                        iconSize: 16,
                        checkDisabled: item => (user?.pessoa.id !== item?.pessoa.id && !eValidador) || !!item.validado,
                        disabledTooltip: 'Não é possível excluir',
                        confirmation: 'Deseja realmente excluir esta atividade?'
                    }
                ]}
                hideOnSmallHeaders={['data_previsao_string', 'duracao', 'validado_string']}
                hideHeadersOffset={820}
                hideOffset={555}
            />
        </Container>
    )
}
